import { InterfaceElementName } from "@uniswap/analytics-events";
import { DollarSign, Terminal } from "react-feather";
import styled from "styled-components";
import { lightTheme } from "theme/colors";

import darkArrowImgSrc from "./images/aboutArrowDark.png";
import lightArrowImgSrc from "./images/aboutArrowLight.png";
import darkDollarImgSrc from "./images/aboutDollarDark.png";
import darkTerminalImgSrc from "./images/aboutTerminalDark.png";
import nftCardImgSrc from "./images/nftCard.png";
import swapCardImgSrc from "./images/swapCard.png";

export const MAIN_CARDS = [
  {
    to: "/swap",
    title: "AI Powered Trading",
    description:
      "Experience the ultimate trading platform on Ethereum. Buy, sell, and explore a diverse range of tokens with ease. Our platform combines user-friendly interfaces with advanced technologies to deliver a seamless trading experience.",
    cta: "Trade",
    darkBackgroundImgSrc: swapCardImgSrc,
    lightBackgroundImgSrc: swapCardImgSrc,
    elementName: InterfaceElementName.ABOUT_PAGE_SWAP_CARD,
  },
  {
    to: "/swap",
    title: "Charting tools",
    description:
      "Access detailed and user-friendly charts for precise market analysis, helping you make informed trading decisions. View real-time order books with comprehensive market depth, enabling effective trade execution and strategy planning",
    cta: "View",
    darkBackgroundImgSrc: swapCardImgSrc,
    lightBackgroundImgSrc: swapCardImgSrc,
    elementName: InterfaceElementName.ABOUT_PAGE_SWAP_CARD,
  },
];

const StyledCardLogo = styled.img`
  min-width: 20px;
  min-height: 20px;
  max-height: 48px;
  max-width: 48px;
`;

export const MORE_CARDS = [
  {
    to: "/swap",
    title: "AI Audits",
    description:
      "Enhance your trading security with our AI-driven contract audits, ensuring the integrity and safety of each transaction.",
    lightIcon: <Terminal color={lightTheme.neutral3} size={48} />,
    darkIcon: <StyledCardLogo src={darkTerminalImgSrc} alt="Developers" />,
    cta: "Scan",
    elementName: InterfaceElementName.ABOUT_PAGE_BUY_CRYPTO_CARD,
  },
  {
    to: "/swap",
    title: "Live Pair Scanning",
    description:
      "Discover trading opportunities instantly with our live pair scanning feature, keeping you ahead in fast-moving markets.",
    lightIcon: <Terminal color={lightTheme.neutral3} size={48} />,
    darkIcon: <StyledCardLogo src={darkTerminalImgSrc} alt="Developers" />,
    cta: "View",
    elementName: InterfaceElementName.ABOUT_PAGE_BUY_CRYPTO_CARD,
  },
];
